import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../_infrastructure/classes/componentBase';
import { AuthService } from '../../_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../_infrastructure/classes/handlers/exceptionManager';

@Component({
    selector: 'app-cookiespopup',
    templateUrl: './cookiespopup.component.html',
    styleUrls: ['./cookiespopup.component.scss'],
})
export class CookiesPopupComponent extends ComponentBase implements OnInit {
    storeValue: string = '';

    constructor(
        protected authService: AuthService,
        protected notificationService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.storeValue = localStorage.getItem('agree') ?? '';
    }

    // Function to set value in Local Storage
    saveDecision() {
        this.storeValue = 'agreed';
        localStorage.setItem('agree', this.storeValue);
    }
}
